import React from 'react';
import './SubLandingHeader.css';
import logoSvg from '../../images/logo.svg';

const SubLandingHeader = () => {
  const anchorForm = () => {
    window.location.href = '#contact-form';
  };

  return (
    <div className="sl__container sl-pad-small">
      <a href="https://lykon.de" className="lykon-logo" aria-label="Lykon">
        <img src={logoSvg} alt="logo" />
      </a>
      <div
        onClick={anchorForm}
        onKeyDown={anchorForm}
        role="button"
        tabIndex={0}
        className="sl-header__register"
      >
        <span type="button">Registrieren</span>
      </div>
    </div>
  );
};

export default SubLandingHeader;
